// Activity categories used in NOC applications. application_hdr.activity_ids
// is a comma-separated list of "<categoryId>" or "<categoryId>:<sub-activity>".
export const ACTIVITY_CATEGORIES = {
  1: 'Desilting/ Deepening',
  2: 'Repair/ rehabilitation of hydraulic structure',
  3: 'Removal of obstruction in water bodies',
  4: 'Infrastructure Arrangements',
  5: 'Quality checking of water',
  6: 'Five years Maintenance by any organization',
};

// "1:Desilting,1:Deepening,5" → { 'Desilting/ Deepening': ['Desilting', 'Deepening'], 'Quality checking of water': [] }
export const groupActivities = (activityIds) => {
  const out = {};
  String(activityIds || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((tok) => {
      const [catId, ...rest] = tok.split(':');
      const sub = rest.join(':').trim();
      const key = ACTIVITY_CATEGORIES[catId] || `Category ${catId}`;
      out[key] = out[key] || [];
      if (sub && !out[key].includes(sub)) out[key].push(sub);
    });
  return out;
};
